<template>
  <v-container>
    <v-row justify="center">
      <h1>eu-bay - Mittelhessen Mail Sendungsverfolgung</h1>
    </v-row>
    <v-row justify="center">
      <v-card width="50%">
        <v-card-text class="black--text">
          <v-row>
            <v-col cols="12">
              <v-text-field
                append-icon="mdi-magnify"
                @keydown.enter="search"
                v-model="shippingNr"
                label="Sendungsverfolgung"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3">
              <b>Sendungsnummer</b>
            </v-col>
            <v-col cols="3">
              <b>Zeitpunkt</b>
            </v-col>
            <v-col cols="6">
              <b>Status der Sendung</b>
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="ma-0 ml-3" inset></v-divider>
          </v-row>
          <v-row v-for="(item, i) in shipments" :key="i">
            <v-col cols="3">{{ item.shipmentNr }}</v-col>
            <v-col cols="3">{{ item.timestamp }}</v-col>
            <v-col style="background-color: #F3F3F3" cols="6">{{ item.status }}</v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>

    <v-snackbar v-model="snackbar">
      {{ message }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "Sendungsverfolgung",

  data: () => ({
    shippingNr: "",
    snackbar: false,
    message: "",
    api_route: "https://tracking.eu-bay.de/api/mhm/shipment/",
    shipments: [],
    testShipments: [
      {
        shipmentNr: "0101001010101",
        timestamp: "17:15",
        status: "Eingang im Depot"
      },
      {
        shipmentNr: "0101001010101",
        timestamp: "18:15",
        status: "Ausgang Depot"
      },
      {
        shipmentNr: "0101001010101",
        timestamp: "19:15",
        status: "Sortierung beim Auslieferungspartner"
      }
    ]
  }),
  created: function() {
    var currentLocation = this.$route.params.id;
    console.log(currentLocation);
    this.shippingNr = currentLocation;

    this.getTrackingInfos();
  },
  methods: {
    search: function() {
      this.$router.push(this.shippingNr);
      this.getTrackingInfos();
    },
    getTrackingInfos: function() {
      this.$http
        .get(this.api_route + this.shippingNr)
        .then(response => {
          // handle success
          console.log(response);
          this.shipments = [];
          if (response.data.barcodeScans.length == 0) {
            this.message =
              "Es liegen für die Sendungsnummer " +
              this.shippingNr +
              " noch keine Informationen vor!";
            this.snackbar = true;
          }
          for (let i = 0; i < response.data.barcodeScans.length; i++) {
            this.shipments.push({
              timestamp: response.data.barcodeScans[i].barcodeScanTimestamp,
              status: response.data.barcodeScans[i].barcodeScanTypeName,
              shipmentNr: this.shippingNr
            });
          }
          console.log(this.shipments);
        })
        .catch(error => {
          // handle error
          this.message =
            "Sendungsnummer " + this.shippingNr + " nicht gefunden!";
          this.snackbar = true;
          console.log(error);
        });
    }
  }
};
</script>
